<template>
  <div class="card">
    <div class="card-body add-alarm-container">
      <form @submit.prevent="submit" class="px-4">
        <LoadingPlugin
          :active.sync="isLoading"
          :is-full-page="fullPage"
          background-color="#f3f3f3"
          :opacity="0.8"
          loader="bars"
        ></LoadingPlugin>

        <SuccessModal
          :show="showSuccessPopup"
          @close="showSuccessPopup = false"
          :msg="$t('success_msg_alarm_edit')"
          :heading="$t('success_heading_alarm_edit')"
        />

        <div class="add-alarm">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label>{{ $t("alarm_name") }}</label>

                  <div class="d-flex align-items-center mb-0">
                    <input type="checkbox" v-model="notifyWhenNormal" />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_back_to_normal") }}
                    </p>
                  </div>
                </div>
                <input
                  type="text"
                  name="name"
                  v-model="title"
                  class="form-control"
                  required
                />
              </div>

              <div class="form-group">
                <label>{{ $t("temp_value") }}</label>

                <div class="d-flex col-gap-1 justify-content-between">
                  <input
                    type="number"
                    step="any"
                    name="name"
                    v-model.number="temperature.min"
                    class="form-control"
                    :placeholder="$t('enter_min_temp')"
                    :required="temperature.max"
                  />

                  <input
                    type="number"
                    step="any"
                    name="name"
                    v-model.number="temperature.max"
                    class="form-control"
                    :placeholder="$t('enter_max_temp')"
                    :required="temperature.min"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("lux") }} {{ $t("optional") }}</label>
                <div class="d-flex col-gap-1 justify-content-between">
                  <input
                    type="number"
                    step="any"
                    name="min_lux"
                    min="0"
                    v-model.number="lux.min"
                    class="form-control"
                    :placeholder="$t('enter_min_lux')"
                  />

                  <input
                    type="number"
                    step="any"
                    name="max_lux"
                    v-model.number="lux.max"
                    class="form-control"
                    :placeholder="$t('enter_max_lux')"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>{{ $t("geo") }}</label>
                <!-- <input
                type="text"
                name="name"
                v-model="geofenceData.id"
                class="form-control"
                required
              /> -->
                <select
                  name="poi"
                  class="form-control"
                  v-model="geofenceData.id"
                >
                  <option value="">
                    {{ $t("select") }}
                  </option>
                  <option
                    v-for="data in geofence"
                    :key="data.id"
                    :value="data.id"
                  >
                    {{ data.name }}
                  </option>
                </select>

                <div class="d-flex col-gap-2 align-items-center mt-2">
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      v-model="geofenceData.notifyWhenIn"
                    />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_in_geo") }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      v-model="geofenceData.notifyWhenOut"
                    />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_out_geo") }}
                    </p>
                  </div>
                </div>
              </div>
              <ComboBox
                :data="sorteddevices"
                :isItemChecked="(device) => selecteddevices.includes(device.id)"
                @checkClick="(device) => updateDevice(device)"
                prefix="devices"
                @doSearch="doSearch"
                :isSelectAll="
                  selecteddevices.length === allSortedDevices.length
                "
                :selectAll="
                  () => (selecteddevices = allSortedDevices.map(({ id }) => id))
                "
                :deSelectAll="() => (selecteddevices = [])"
                :label="$t('add_devices')"
                :errorMessage="
                  errors.includes('devices')
                    ? 'Pls select at least one device'
                    : ''
                "
              />
              <div class="form-group">
                <label>
                  {{ $t("mode_of_alarm") }}
                </label>
                <select
                  id="mode-of-alarm"
                  v-model="modeOfAlarm"
                  name="mode-of-alarm"
                  class="form-control"
                >
                  <option value="" disabled selected>
                    {{ $t("select_mode") }}
                  </option>
                  <option
                    v-for="{ label, value } in modeOfAlarmOptions"
                    :key="value"
                    :value="value"
                  >
                    {{ label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label>{{ $t("delay_alarm") }} </label>
                <div class="d-flex col-gap-1 justify-content-between">
                  <select
                    name="alarm-delay"
                    class="form-control"
                    v-model="delay"
                  >
                    <option value="" disabled>
                      {{ $t("select_delay") }}
                    </option>
                    <option
                      v-for="option in delayOptions"
                      :key="option.id"
                      :value="option.value"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                  <select
                    name="device"
                    class="form-control"
                    v-model="delayValue"
                    required
                  >
                    <option value="" disabled selected>
                      {{
                        $t(
                          delay === "time"
                            ? "select_time"
                            : delay === "frequency"
                            ? "select_freq"
                            : "select_time_freq",
                        )
                      }}
                    </option>
                    <option
                      v-for="{ label, value } in getDelayOptions"
                      :key="value"
                      :value="value"
                    >
                      {{ label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("humid_value") }}</label>
                <div class="d-flex col-gap-1 justify-content-between">
                  <input
                    type="number"
                    step="any"
                    name="name"
                    v-model.number="humidity.min"
                    class="form-control"
                    :placeholder="$t('enter_min_humid')"
                    :required="humidity.max"
                  />

                  <input
                    type="number"
                    step="any"
                    name="name"
                    v-model.number="humidity.max"
                    class="form-control"
                    :placeholder="$t('enter_max_humid')"
                    :required="humidity.min"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("battery_value") }}</label>
                <div class="d-flex col-gap-1 justify-content-between">
                  <input
                    type="number"
                    step="any"
                    name="name"
                    v-model.number="battery.min"
                    class="form-control"
                    :placeholder="$t('enter_min_battery')"
                    :required="battery.max"
                  />

                  <input
                    type="number"
                    step="any"
                    name="name"
                    v-model.number="battery.max"
                    class="form-control"
                    :placeholder="$t('enter_max_battery')"
                    :required="battery.min"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("POI") }}</label>
                <!-- <input
                type="text"
                name="name"
                v-model="poiData.id"
                class="form-control"
                required
              /> -->
                <select name="poi" class="form-control" v-model="poiData.id">
                  <option value="">
                    {{ $t("select") }}
                  </option>
                  <option v-for="data in POI" :key="data.id" :value="data.id">
                    {{ data.name }}
                  </option>
                </select>

                <div class="d-flex col-gap-2 align-items-center mt-2">
                  <div class="d-flex align-items-center">
                    <input type="checkbox" v-model="poiData.notifyWhenIn" />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_in_poi") }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center">
                    <input type="checkbox" v-model="poiData.notifyWhenOut" />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_out_poi") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("webhook") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="webhook"
                  class="form-control"
                  :placeholder="$t('enter_webhook')"
                />
                <div v-if="errors.includes('webhook')" class="error">
                  This needs to be a valid url
                </div>
              </div>

              <ComboBox
                :data="getUsersForModeOfAlarm"
                prefix="users"
                :isItemChecked="
                  (user) => selectedusers.map(({ id }) => id).includes(user.id)
                "
                @checkClick="(user) => updateUser(user)"
                @doSearch="doSearchUser"
                :isSelectAll="
                  getUsersForModeOfAlarm.length === selectedusers.length
                "
                :selectAll="
                  () =>
                    (selectedusers = getUsersForModeOfAlarm.map(
                      ({ value, id }) => ({
                        value,
                        id,
                      }),
                    ))
                "
                :deSelectAll="() => (selectedusers = [])"
                :label="$t('add_users_staff_email')"
                :isDisabled="!modeOfAlarm"
                :selected="selectedusers"
                :showValues="true"
                @removeItem="removeASelectedUser"
                :errorMessage="
                  errors.includes('users') ? 'Pls select at least one user' : ''
                "
              />
            </div>
          </div>

          <div class="line-divider"></div>

          <div
            class="d-flex justify-content-between align-items-center mt-3 mb-3"
          >
            <span class="add-header">{{ $t("add_escalation_tree") }}</span>

            <button
              class="add-btn"
              @click="addLevel"
              type="button"
              v-if="levels.length < 3"
            >
              <span>+</span>
              <span>Add Level</span>
            </button>
          </div>

          <div v-for="level in levels" :key="level.id">
            <div class="level-row">
              <div class="d-flex col-gap-1 justify-content-between">
                <div class="form-group w-50">
                  <label>
                    {{ $t("mode_of_alarm") }}
                  </label>
                  <select
                    id="mode-of-alarm"
                    name="mode-of-alarm"
                    class="form-control"
                    @input="handleLevelInput($event, level)"
                    :value="level.modeOfAlarm"
                  >
                    <option value="" disabled selected>
                      {{ $t("select_mode") }}
                    </option>
                    <option
                      v-for="{ label, value } in modeOfAlarmOptions"
                      :key="value"
                      :value="value"
                    >
                      {{ label }}
                    </option>
                  </select>
                  <div
                    v-if="level.errors.includes('modeOfAlarm')"
                    class="error"
                  >
                    Pls select a mode of alarm
                  </div>
                </div>
                <div class="form-group w-50">
                  <label>
                    {{ $t("time_int") }}
                  </label>
                  <select
                    id="time-interval"
                    name="time-interval"
                    class="form-control"
                    @input="handleLevelInput($event, level)"
                    :value="level.levelTimeInterval"
                  >
                    <option value="" disabled selected>
                      {{ $t("select_time") }}
                    </option>
                    <option
                      v-for="{ label, value } in timeInterval"
                      :key="value"
                      :value="value"
                    >
                      {{ label }}
                    </option>
                  </select>
                  <div v-if="level.errors.includes('time')" class="error">
                    Pls select a time interval
                  </div>
                </div>
              </div>
              <ComboBox
                :data="getUsersForLevel(level)"
                :isItemChecked="
                  (user) =>
                    level.levelselectedusers
                      .map(({ id }) => id)
                      .includes(user.id)
                "
                @checkClick="(user) => updateLevelUsers(user, level)"
                prefix="escalation-level-users"
                @doSearch="doSearchUser"
                :selectAll="() => selectAllUsersForLevel(level)"
                :deSelectAll="() => deSelectAllUsersForLevel(level)"
                :label="$t('add_users_staff_email')"
                :isDisabled="!level.modeOfAlarm"
                :selected="level.levelselectedusers"
                :showValues="true"
                @removeItem="
                  (userId) => removeASelectedLevelUser(userId, level)
                "
                :isSelectAll="users.length === level.levelselectedusers.length"
                :errorMessage="
                  level.errors.includes('users')
                    ? 'Pls select at least one user'
                    : ''
                "
              />
              <button
                class="delete"
                :class="{ 'move-up': level.errors.length > 0 }"
                @click="removeLevel(level.id)"
              >
                <img src="./../../assets/images/delete.svg" alt="delete" />
              </button>
            </div>
          </div>
          <div class="row w-100 mt-4">
            <div class="line-divider w-100 mb-3 mt-1"></div>
            <div class="d-flex align-items-center mt-3 col-12">
              <input
                type="checkbox"
                v-model="isHardwareAlarm"
                id="hardware-alarm"
              />
              <label for="hardware-alarm" class="ml-2 mb-0" style="margin-left: 8px;">
                {{ $t("hardware_alarms") || "Hardware Alarms" }}
              </label>
            </div>
            <div v-if="isHardwareAlarm" class="mt-2 col-12">
              <div class="form-group w-50">
                <label>{{ $t("select_hardware_alarm") || "Select Hardware Alarm" }}</label>
                <select
                  id="hardware-alarm-select"
                  name="hardware-alarm-select"
                  class="form-control"
                  v-model="hardwareAlarmImei"
                >
                  <option value="" disabled selected>
                    {{ $t("select_hardware") || "Select Hardware Alarm" }}
                  </option>
                  <option
                    v-for="hw in hardwareAlarms"
                    :key="hw.imei"
                    :value="hw.imei"
                  >
                    {{ hw.name }} ({{ hw.imei }})
                  </option>
                </select>
                <div v-if="hardwareAlarms.length === 0" class="error mt-1">
                  No assigned hardware alarms available. Please contact Support.
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div
              class="d-flex align-items-center justify-content-end col-gap-1 w-100"
            >
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="!atLeastOneAlarmType"
              >
                {{ $t("save") }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ComboBox from "../../components/ComboBox.vue";
import LoadingPlugin from "vue-loading-overlay";
import SuccessModal from "../Modals/SuccessModal.vue";
// import users from "../../store/modules/users";
export default {
  name: "AlarmSettings",
  props: {
    step: Number,
  },
  computed: {
    ...mapGetters([
      "alarms",
      "profile",
      "devices",
      "users",
      "geofence",
      "POI",
      "alarm",
      "hardwareAlarms",
    ]),
    atLeastOneAlarmType() {
      return (
        !!this.temperature.min ||
        !!this.humidity.min ||
        !!this.geofenceData.id ||
        !!this.poiData.id
      );
    },
    getDelayOptions() {
      if (this.delay === "time") return this.timeInterval;
      if (this.delay === "frequency") return this.frequencyOptions;

      return [];
    },
    getUsersForModeOfAlarm() {
      // let activeusers = this.singlegroup.users.map((user) => user.email);

      if (this.modeOfAlarm === "email") {
        return this.users.map(({ email, ...rest }) => ({
          name: email,
          value: email,
          ...rest,
        }));
      }
      return this.users.map(({ phone, fullname, ...rest }) => ({
        name: `+${phone} - ${fullname}`,
        value: phone,

        ...rest,
      }));
    },
    computedLevelToBeWatched() {
      return this.levels.map((level) => ({ ...level }));
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      sorteddevices: [],
      allSortedDevices: [],
      selecteddevices: [],

      sortedusers: [],
      allSortedUsers: [],
      selectedusers: [],

      sortedPhones: [],
      allSortedPhones: [],
      selectedPhones: [],
      webhook: "",
      selectedIndex: 0,
      show: false,
      isShow: false,
      isHardwareAlarm: false,
      hardwareAlarmImei: "",
      selectedIndexes: [],
      title: "",
      temperature: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      humidity: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      battery: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      poiData: {
        id: "",
        notifyWhenIn: true,
        notifyWhenOut: true,
      },
      geofenceData: {
        id: "",
        notifyWhenIn: true,
        notifyWhenOut: true,
      },
      delay: "",

      timeInterval: [
        { label: "5 mins", value: 5 },
        { label: "10 mins", value: 10 },
        { label: "15 mins", value: 15 },
        { label: "30 mins", value: 30 },
        { label: "45 mins", value: 45 },
        { label: "1 hr", value: 60 },
        { label: "2 hrs", value: 120 },
        { label: "4 hrs", value: 240 },
        { label: "6 hrs", value: 360 },
        { label: "12 hrs", value: 720 },
        { label: "24 hrs", value: 1440 },
      ],
      frequencyOptions: [
        { label: 1, value: "1" },
        { label: 2, value: "2" },
        { label: 3, value: "3" },
        { label: 4, value: "4" },
        { label: 5, value: "5" },
        { label: 6, value: "6" },
        { label: 7, value: "7" },
        { label: 8, value: "8" },
        { label: 9, value: "9" },
      ],
      delayOptions: [
        { id: 1, label: "Delay by time", value: "time" },
        { id: 2, label: "Delay by frequency", value: "frequency" },
      ],
      delayValue: "",
      lux: {
        max: null,
        min: null,
        notifyWhenNormal: true,
      },

      modeOfAlarm: "",

      modeOfAlarmOptions: [
        { label: "Email", value: "email" },
        { label: "SMS", value: "sms" },
        { label: "Whatsapp", value: "whatsapp" },
      ],
      notifyWhenNormal: true,
      showSuccessPopup: false,
      levels: [],
      errors: [],
    };
  },
  mounted() {
    this.getHardwareAlarms();
    this.sorteddevices = this.devices
      // .filter((device) => !device.group)
      .map(({ settings, ...rest }) => ({
        name: settings.name,
        settings,
        ...rest,
      }));
    this.allSortedDevices = this.sorteddevices;

    // let activeusers = this.singlegroup.users.map((user) => user.email);
    this.sortedusers = this.users
      //   .filter((user) => !activeusers.includes(user.email))
      .map(({ email, ...rest }) => ({
        name: email,
        email,
        ...rest,
      }));
    this.allSortedUsers = this.sortedusers;

    this.sortedPhones = this.users
      //   .filter((user) => !activeusers.includes(user.email))
      .map(({ phone, id, ...rest }) => ({
        name: phone,
        phone,
        phoneId: id,
        ...rest,
        id: phone,
      }));
    this.allSortedPhones = this.sortedPhones;
  },
  methods: {
    ...mapActions(["updateAlarm", "getAlarmById", "getHardwareAlarms"]),
    updateDevice(val) {
      const index = this.selecteddevices.indexOf(val.id);

      if (index !== -1) {
        // If the deviceTag is already in the array, remove it
        this.selecteddevices.splice(index, 1);
      } else {
        // If the deviceTag is not in the array, add it along with deviceName
        this.selecteddevices = [...this.selecteddevices, val.id];
      }
    },
    doSearch({ target: { value } }) {
      const filtered = this.allSortedDevices.filter(
        ({ settings: { name }, group }) =>
          name.toLowerCase().includes(value.toLowerCase()),
      );
      this.sorteddevices = filtered;
    },
    doSearchUser({ target: { value } }) {
      //   let activeusers = this.singlegroup.users.map((user) => user.email);
      const filtered = this.users
        .filter((user) =>
          user.email.toLowerCase().includes(value.toLowerCase()),
        )
        .map(({ email, ...rest }) => ({
          name: email,
          ...rest,
        }));
      this.sortedusers = filtered;
    },
    updateUser(val) {
      // const index = this.selectedusers.indexOf(val.email);
      const index = this.selectedusers.indexOf(val.id);
      if (index !== -1) {
        this.selectedusers.splice(index, 1);
      } else {
        this.selectedusers = [
          ...this.selectedusers,
          { value: val.value, id: val.id },
        ];
      }
    },
    removeASelectedUser(id) {
      this.selectedusers = this.selectedusers.filter((item) => item.id !== id);
    },

    updateLevelUsers(user, level) {
      // find the level that needs to be updated
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id,
      );

      // find the user that its checkbox is toggled
      const editedUser = editedLevel.levelselectedusers.find(
        (levelUser) => levelUser.id === user.id,
      );

      // if the user is in the array, reset the level by removing the user else add the user
      if (editedUser)
        editedLevel.levelselectedusers = editedLevel.levelselectedusers.filter(
          (levelUser) => levelUser.id !== user.id,
        );
      else
        editedLevel.levelselectedusers = [
          ...editedLevel.levelselectedusers,
          user,
        ];

      // find the level that needs to be updated and use the updated user obj for it
      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },

    removeASelectedLevelUser(userId, level) {
      // find the level that needs to be updated
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id,
      );

      // find the user that its checkbox is toggled
      editedLevel.levelselectedusers = editedLevel.levelselectedusers.filter(
        (levelUser) => levelUser.id !== userId,
      );

      // find the level that needs to be updated and use the updated user obj for it
      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },
    selectAllUsersForLevel(level) {
      // find the level that all its users need to be selected
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id,
      );

      // set the level's selected user to all users
      editedLevel.levelselectedusers = this.getUsersForLevel(level);

      // find the level that all its users need to be selected and set the selected users to the edited version

      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },
    deSelectAllUsersForLevel(level) {
      // find the level that all its users need to be selected
      const editedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id,
      );

      // set the level's selected user to all users
      editedLevel.levelselectedusers = [];

      // find the level that all its users need to be selected and set the selected users to the edited version
      console.log(editedLevel, "edited level");
      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return editedLevel;
        return levelItem;
      });
    },
    getUsersForLevel(levelArg) {
      const level = this.levels.find(
        (levelItem) => levelItem.id === levelArg.id,
      );
      console.log(level, "users for level");
      if (!level) return [];

      if (level.modeOfAlarm === "email") {
        return this.users.map(({ email, ...rest }) => ({
          name: email,
          value: email,
          ...rest,
        }));
      }

      return this.users.map(({ phone, fullname, ...rest }) => ({
        name: `+${phone} - ${fullname}`,
        value: phone,
        ...rest,
      }));
    },
    updateLevelErrors(id, errorToRemove) {
      this.levels = this.levels.map((level) => {
        if (level.id === id) {
          return {
            ...level,
            errors: level.errors.filter((err) => err !== errorToRemove),
          };
        }
        return level;
      });
    },
    validateURL(string) {
      try {
        new URL(string);
        return true;
      } catch (err) {
        return false;
      }
    },
    validatePayload() {
      if (
        this.selecteddevices.length === 0 &&
        !this.errors.includes("devices")
      ) {
        this.errors.push("devices");
      }

      if (this.selectedusers.length === 0 && !this.errors.includes("users")) {
        this.errors.push("users");
      }
      if (
        this.webhook !== "" &&
        !this.validateURL(this.webhook) &&
        !this.errors.includes("webhook")
      ) {
        this.errors.push("webhook");
      }
      if (this.levels.length > 0) {
        const uncompletedLevels = this.levels
          .filter(
            (level) =>
              !level.levelTimeInterval ||
              !level.modeOfAlarm ||
              level.levelselectedusers.length === 0,
          )
          .map((level) => level.id);
        if (uncompletedLevels.length > 0) {
          this.levels = this.levels.map((level) => {
            if (uncompletedLevels.includes(level.id)) {
              let levelErrors = [];
              if (!level.levelTimeInterval) levelErrors.push("time");
              if (!level.modeOfAlarm) levelErrors.push("modeOfAlarm");
              if (level.levelselectedusers.length === 0)
                levelErrors.push("users");
              return {
                ...level,
                errors: levelErrors,
              };
            }
            return level;
          });
          if (!this.errors.includes("level")) this.errors.push("level");

          console.log(this.errors);
        } else {
          if (this.errors.includes("level"))
            this.errors = this.errors.filter((item) => item !== "level");
        }
      }

      if (this.errors.length > 0) return false;
      return true;
    },

    addLevel() {
      const levelDetails = {
        modeOfAlarm: "",
        levelTimeInterval: "",
        errors: [],
        levelselectedusers: [],
        id:
          this.levels.length === 0
            ? 1
            : this.levels[this.levels.length - 1].id + 1,
      };

      this.levels.push(levelDetails);
    },
    removeLevel(levelId) {
      console.log(levelId, "level id");
      this.levels = this.levels.filter((level) => level.id !== levelId);
    },

    handleLevelInput(event, level) {
      // find the level that its input field is changing
      const changedLevel = this.levels.find(
        (levelItem) => levelItem.id === level.id,
      );
      const { value, name } = event.target;

      // check if the mode of alram is being changed or the time interval
      if (name === "mode-of-alarm") {
        changedLevel.modeOfAlarm = value;
      }

      if (name === "time-interval") {
        changedLevel.levelTimeInterval = value;
      }
      changedLevel.levelselectedusers = [];
      // reset the level with the updated value

      this.levels = this.levels.map((levelItem) => {
        if (levelItem.id === level.id) return changedLevel;
        return levelItem;
      });
    },

    doSearchPhone({ target: { value } }) {
      //   let activeusers = this.singlegroup.users.map((user) => user.email);
      const filtered = this.users
        .filter((user) =>
          user.phone.toLowerCase().includes(value.toLowerCase()),
        )
        .map(({ phone, ...rest }) => ({
          name: phone,
          ...rest,
          id: phone,
        }));
      this.sortedPhones = filtered;
    },
    updatePhone(val) {
      const index = this.selectedPhones.indexOf(val.phoneId);
      if (index !== -1) {
        this.selectedPhones.splice(index, 1);
      } else this.selectedPhones = [...this.selectedPhones, val.phoneId];

      // const index = this.selectedPhones.findIndex(
      //   (item) => item.phone === val.phone
      // );

      // if (index !== -1) {
      //   // If the deviceTag is already in the array, remove it
      //   this.selectedPhones.splice(index, 1);
      // } else {
      //   // If the deviceTag is not in the array, add it along with deviceName
      //   this.selectedPhones = [
      //     ...this.selectedPhones,
      //     { phone: val.phone, name: val.fullname, id: val.phoneId },
      //   ];
      // }
    },

    toggleAccordion(index) {
      // this.selectedIndex = this.selectedIndex === index ? -1 : index;
      if (this.selectedIndexes.includes(index)) {
        this.selectedIndexes = this.selectedIndexes.filter(
          (idx) => idx !== index,
        );
      } else this.selectedIndexes = [...this.selectedIndexes, index];
    },
    submit() {
      if (!this.validatePayload()) return;
      const payload = {
        title: this.title,
        devices: this.selecteddevices,
        temperature: this.temperature.min ? this.temperature : undefined,
        humidity: this.humidity.min ? this.humidity : undefined,
        light: (this.lux.min ?? null) !== null ? this.lux : undefined,

        battery: this.battery.min ? this.battery : undefined,
        notifyWhenNormal: true,
        poi: this.poiData.id ? this.poiData : undefined,
        geofence: this.geofenceData.id ? this.geofenceData : undefined,
        intervalMinutes: this.intervalMinutes,
        notify: {
          phoneUsers:
            this.modeOfAlarm === "sms" && this.selectedusers?.length > 0
              ? this.selectedusers.map((user) => user.id)
              : undefined,
          emailUsers:
            this.modeOfAlarm === "email" && this.selectedusers?.length > 0
              ? this.selectedusers.map((user) => user.id)
              : undefined,
          whatsAppUsers:
            this.modeOfAlarm === "whatsapp" && this.selectedusers?.length > 0
              ? this.selectedusers.map((user) => user.id)
              : undefined,
          webhookURL: this.webhook ? this.webhook : undefined,
          // webhookURL: this.webhook,
        },
        escalationTree:
          this.levels.length > 0
            ? this.levels.map((alarmLevel) => {
                return {
                  mode: alarmLevel.modeOfAlarm,
                  interval: Number(alarmLevel.levelTimeInterval),
                  level: alarmLevel.levelselectedusers.map((user) => user.id),
                };
              })
            : undefined,
        company: this.alarm.company,
        isHardwareAlarm: this.isHardwareAlarm || undefined,
        hardwareAlarmImei: (this.isHardwareAlarm && this.hardwareAlarmImei) ? this.hardwareAlarmImei : undefined,
        hardwareAlarmEnabled: this.isHardwareAlarm ? true : undefined,
      };

      console.log("payload", this.selectedusers, payload);
      this.isLoading = true;
      this.updateAlarm({ id: this.$route.params.alarmId, newValue: payload })
        .then(() => {
          this.showSuccessPopup = true;
          this.getAlarmById(this.$route.params.alarmId).then(() => {
            this.isLoading = false;
          });
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            //console.log(error.response.data.message);
          }
        });
    },
  },
  components: {
    ComboBox,
    LoadingPlugin,
    SuccessModal,
  },
  watch: {
    delay(_, oldVal) {
      if (!oldVal) return;
      this.delayValue = "";
    },
    modeOfAlarm(_, oldVal) {
      if (!oldVal) return;
      this.selectedusers = [];
    },
    selectedusers() {
      if (this.errors.includes("users"))
        this.errors = this.errors.filter((item) => item !== "users");
    },
    selecteddevices() {
      if (this.errors.includes("devices"))
        this.errors = this.errors.filter((item) => item !== "devices");
    },
    webhook() {
      if (
        (this.errors.includes("webhook") && this.validateURL(this.webhook)) ||
        this.webhook === ""
      )
        this.errors = this.errors.filter((item) => item !== "webhook");
    },
    computedLevelToBeWatched: {
      handler(newValue, oldValue) {
        if (!oldValue || !newValue) return;

        newValue.forEach((newItem) => {
          const oldItem = oldValue.find((item) => item.id === newItem.id);

          if (!oldItem) return;

          // check and update "modeOfAlarm" error
          if (
            !oldItem.modeOfAlarm &&
            oldItem.errors.includes("modeOfAlarm") &&
            newItem.modeOfAlarm
          ) {
            this.updateLevelErrors(newItem.id, "modeOfAlarm");
          }

          // check and update "time" error
          if (
            !oldItem.levelTimeInterval &&
            oldItem.errors.includes("time") &&
            newItem.levelTimeInterval
          ) {
            this.updateLevelErrors(newItem.id, "time");
          }

          // check and update "users" error
          if (
            oldItem.levelselectedusers.length === 0 &&
            oldItem.errors.includes("users") &&
            newItem.levelselectedusers.length > 0
          ) {
            this.updateLevelErrors(newItem.id, "users");
          }
        });
      },
      deep: true,
    },
    alarm: {
      handler() {
        const {
          title,
          devices,
          temperature,
          battery,
          notifyWhenNormal,
          poi,
          geofence,
          hummidity,
          escalationTree,
          notify: { emails, phones, webhookURL, whatsapps },
          delay,
          light,
          isHardwareAlarm,
          hardwareAlarmImei,
        } = this.alarm;
        this.title = title;
        if (delay?.by) this.delay = delay.by;
        if (delay?.value) {
          this.delayValue = delay.value;
        }

        if (temperature) {
          this.temperature = temperature;
        }
        if (hummidity) this.humidity = hummidity;

        if (light) this.lux = light;
        if (battery) this.battery = battery;
        if (isHardwareAlarm) this.isHardwareAlarm = isHardwareAlarm;
        if (hardwareAlarmImei) this.hardwareAlarmImei = hardwareAlarmImei;
        this.notifyWhenNormal = notifyWhenNormal;
        if (geofence) this.geofenceData = geofence;
        if (poi) this.poiData = poi;
        if (webhookURL) this.webhook = webhookURL;
        if (escalationTree.length > 0) {
          this.levels = escalationTree.map(
            ({ mode, interval, level }, index) => {
              return {
                id: index + 1,
                modeOfAlarm: mode,
                levelTimeInterval: interval,
                errors: [],
                levelselectedusers: this.users
                  .filter((user) => level.includes(user.id))
                  .map((user) => {
                    if (mode === "email") {
                      return {
                        name: user.email,
                        value: user.email,
                        ...user,
                      };
                    } else {
                      return {
                        name: `+${user.phone} - ${user.fullname}`,
                        value: user.phone,
                        ...user,
                      };
                    }
                  }),
              };
            },
          );
        }
        this.selecteddevices = devices;
        this.selectedPhones = phones;

        // check the first selected users if it's an email then the mode of alarm is email else it's sms/whatsapp
        if (phones.length > 0) {
          this.modeOfAlarm = "sms";
          this.selectedusers = this.users
            .filter((user) => phones.includes(user.id))
            .map(({ id, email }) => ({ value: email, id }));
        }
        if (whatsapps.length > 0) {
          this.modeOfAlarm = "whatsapp";
          this.selectedusers = this.users
            .filter((user) => whatsapps.includes(user.id))
            .map(({ id, email }) => ({ value: email, id }));
        }
        if (emails.length > 0) {
          this.modeOfAlarm = "email";
          this.selectedusers = this.users
            .filter((user) => emails.includes(user.id))
            .map(({ id, email }) => ({ value: email, id }));
        }
      },

      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}

.add-header {
  color: #404a57;
}

.add-btn {
  background: transparent;
  color: #213e7a;
  border: 0px;
  font-size: 14px;
  width: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-btn span:first-child {
  font-size: 20px;
  transform: translateY(-2px);
}
.add-btn:focus,
.add-btn:active {
  border: 0px;
  outline: 0px;
}
.step-3 .card {
  border-radius: 12px;
  background: #fff;

  /* Style 2 */
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
}
.level-row {
  display: grid;
  grid-template-columns: 1fr 1fr 50px;
  gap: 10px;
  width: 100%;
  align-items: start;
}
.delete {
  color: #dc3030;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dc3030;
  padding: 5px;
  border-radius: 5px;
  width: 20px;
  height: 20px;
  align-self: center;
  cursor: pointer;
}
.move-up {
  transform: translateY(-10px);
}
/* .slide-enter-active,
  .slide-leave-active {
    transition: max-height 3.5s;
  }
  .slide-enter-from {
    max-height: 0;
  }
  .slide-leave-to {
    max-height: 100px;
  }
  
  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }
  
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  
  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  } */

ul {
  cursor: pointer;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.line-divider {
  width: 100%;
  height: 1px;
  background-color: #0000001a;
}
.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

/* @media (min-width: 768px) {
    .add-alarm {
      padding: 1rem;
    }
  }
  
  @media (min-width: 1600px) {
      .add-alarm {
      padding: 2rem;
    }
  } */

@media (min-width: 768px) {
  .add-alarm-container {
    padding: 20px 2rem;
  }
}

@media (min-width: 1600px) {
  .add-alarm-container {
    padding: 40px 3rem;
  }
}
/* @media (min-width: 1600px) {
  .add-alarm-container {
    padding: 0 2rem;
  }
} */
</style>
